<template>
    <div class="form-separator">
        <hr />
        <div>
            <span v-if="text">{{ $tm(text) }}</span>
        </div>
    </div>
</template>
<script setup lang="ts">
import { $tm } from '@/locize';

defineProps<{ text?: string }>();
</script>
